import axios from '@/libs/axios'

export default {
  createPortalSession() {
    return axios.post('/payments/portal-session')
  },
  retryPayment() {
    return axios.post('/payments/retry-payment')
  },
}
